const CONSTANTS = module.exports = {};

CONSTANTS.BANK_TRANSFER_BUSINESS_DAYS_BEFORE_DEADLINE = 4;

CONSTANTS.BANK_TRANSFER_MAX_FILE_SIZE_BYTES = 10 * 1024 * 1024; // 10 MB per file
CONSTANTS.BANK_TRANSFER_MAX_FILES = 10; // not a stated business rule — just a sane abuse-prevention cap
CONSTANTS.BANK_TRANSFER_ALLOWED_MIME_TYPES = ['application/pdf', 'image/jpeg', 'image/png'];
